import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/core/service/config.service';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import { ConfirmComponent } from 'src/app/shared/actions/delete/confirm.component';

@Component({
  selector: 'app-owner-auction-config',
  templateUrl: './owner-auction-config.component.html'
})
export class OwnerAuctionConfigComponent implements OnInit {
  @Input() auctionStatus: any;
  @Input() startDateTimer: any;
  @Input() endDateTimer: any;
  @Input() number: any;
  @Input() auctionData: any;
  @Input() lastbid: any;
  @Input() LastBidder: any;
  @Input() bidders: any;
  @Input() timeExtended: any;
  subscriptions: Subscription[] = [];

  @Output() reloadPage = new EventEmitter<any>();
  @Output() AuctionEnded = new EventEmitter<any>();

  showConfirmSold: boolean = false;
  loadingBtnRequest: boolean = false;

  remaining = true;
  intervalRemaining: any;
  constructor(
    private dialog: MatDialog,
    public _config: ConfigService,
    private _auctions: AuctionsService,
    public socket: SocketService
  ) { }

  ngOnInit() {
    if (this.auctionStatus == 'ongoing') {
      this.getRemainingSocket();
    }
  }
  checkShowConfirmSold() {

    // setInterval(() => {
    //   const currentTime = moment().unix();
    //   const fiveMinutesAgo = moment(this.endDateTimer).subtract(5, 'minutes').unix();
    //   if (currentTime > fiveMinutesAgo) {
    //     this.showConfirmSold = true;
    //   }
    // }, 500);

    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed && this.auctionData?.remaining_time <= 300) {
    //   this.showConfirmSold = true;
    // }
  }


  AdminConfirmSolid() {
    const dataConfirmActions = {
      title: this._config.translate.instant("actions.confirmTitle"),
      icon: 'warning',
      text: this._config.translate.instant("actions.confirmTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'success') {
        this.loadingBtnRequest = true;
        this._auctions.endAuctionWithWinner(this.auctionData.id).subscribe({
          next: (data: any) => {
            // const auctionInfo = {
            //   auctionId: this.auctionData.id
            // }
            // this.socket.socket.emit("reloadPage", auctionInfo);
            this.reloadPage.emit();

            this.loadingBtnRequest = false;
            // location.reload();
            this._config.toastrService.success(data.message);
          }, error: (error: any) => {
            this.loadingBtnRequest = false;
            this._config.showErrors(error)
          }
        });

      }
    })
  }

  getRemaining() {

    // console.log(event);

    // this.auctionData.remaining_time = event;

    // if (this.auctionData?.is_reserve && !this.auctionData?.is_closed) {
    //   this.showConfirmSold = true;
    // }
    // if (this.remaining && this.auctionData.remaining_time < 60 && this.auctionStatus == "ongoing") {
    //   this.remaining = false;
    //   this.intervalRemaining = setInterval(() => {
    //     this.socket?.socket?.emit("getRemaining", this.auctionData.id);
    //   }, 2000)



    // }

  }
  getRemainingSocket() {
    this.subscriptions.push(
      this.socket.getDataStream<string>("getRemaining" + this.auctionData.id)
        .subscribe(message => {


          this.auctionData.remaining_time = message.data.response;
          if (this.auctionData?.is_reserve && !this.auctionData?.is_closed && message.data.response <= 300) {
            this.showConfirmSold = true;
          }
          if (message.data.response == 0) {
            this.OnReload('ongoing');
          }
          if (this.auctionData?.is_reserve && !this.auctionData?.is_closed && message.data.response <= 300) {
            this.showConfirmSold = true;
          }

        })
    )
  }
  OnReload(status: string) {
    if (status == 'upcoming') {
      this.auctionStatus = 'ongoing';
      this.getRemainingSocket();
    } else {
      this.auctionStatus = 'end';
      this.AuctionEnded.emit(true);

    }
  }
}
